import { ZodError, z } from 'zod';

const envSchema = z.object({
  DEV: z.boolean(),
  VITE_BACKEND_URL: z.url(),
  VITE_CLIENT_URL: z.url(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_WS_URL: z.url(),
  VITE_LANDING_URL: z.url(),
});

export type SafeEnv = z.infer<typeof envSchema>;

let envConfig: SafeEnv;

try {
  envConfig = envSchema.parse(import.meta.env);
} catch (error) {
  if (error instanceof ZodError) {
    throw new Error('Invalid environment variables');
  }
}

export { envConfig };
